import type { MembershipRecord } from '@libs/data-access/entities'
import { Anchor, Badge } from '@libs/ui/ds'
import { useCommonAppTranslation } from '@libs/utils/translations'
import { routes } from '@spa/core/router'
import { useMemoSelector } from '@spa/redux/hooks'
import React from 'react'
import type { FC } from 'react'
import { Link, generatePath } from 'react-router-dom'
import { getTeamById } from 'snap-redux/modules/teams/selectors'

type Props = {
  membership: MembershipRecord
}
const UsersWithoutEmailsItem: FC<Props> = ({ membership }) => {
  const { t } = useCommonAppTranslation()
  const team = useMemoSelector(state =>
    // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
    getTeamById(state, membership.most_relevant_contract.get('team_id'))
  )

  return (
    <Anchor
      component={Link}
      to={generatePath(routes.member.rootPath, {
        view: 'preview',
        membership_id: membership?.id
      })}
      variant='inherits'
      className='flex gap-2 text-neutral-700'
    >
      {t('models.fullname', {
        value: {
          firstname: membership?.get('firstname'),
          lastname: membership?.get('lastname')
        }
      })}
      <Badge label={team?.name} size='s' />
    </Anchor>
  )
}

export default UsersWithoutEmailsItem
